import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: string;
  chapters: number;
  status: string;
  tags: string[];
  updateTime: string;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  rating,
  views,
  chapters,
  status,
  tags,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block"
      data-product-shop=""
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${title} - 韩国漫画`}
        />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-[10px] font-medium bg-primary-500/90 text-white rounded-full whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-white text-xs">
            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
            <span className="font-semibold">{rating}</span>
            <span className="ml-auto text-white/70">{views}</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{author}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
        <span>共{chapters}话</span>
      </div>
      <div className="flex items-center gap-2 mt-1">
        <span className={`text-[11px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
          status === '连载中'
            ? 'bg-primary-100 text-primary-700'
            : 'bg-secondary-100 text-secondary-700'
        }`}>
          {status}
        </span>
      </div>
    </Link>
  );
}